/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", function () {
  if ($(".lessonsShowView, .lessonActivitiesIndexView").length) {
    return new App.lessonsAll()
  }
})

window.App.lessonsAll = class lessonsAll {
  constructor() {
    this.loadCarousel()
    this.checkForFeedback()
    this.panelScrollCheck()
    this.bindElements()
    this.bindLogView()
    this.bindLessonToolbar()
    this.$videoContainer = $(".videoContainer")
    new CollapsibleBehavior()
  }

  loadCarousel() {
    if ($(".carouselContainer.review").length) {
      $(".carouselContainer.review").carouFredSel(
        {
          auto: false,
          circular: false,
          infinite: false,
          items: {
            visible: 1,
          },
          scroll: {
            items: 1,
            fx: "scroll",
            duration: 350,
            easing: "easeOutQuart",
            onAfter(data) {
              // @panelScrollCheck() # I'm not sure what this does?
              if (
                $(this).triggerHandler("currentVisible").hasClass("hasFeedback")
              ) {
                $(this)
                  .triggerHandler("currentVisible")
                  .find(".mark-feedback-read-trigger")
                  .click()
              }

              const $el = $(".panel.review")
              const url = $el.data("url")
              const currentPanel =
                $el.find(".uiCycleNav").find(".selected").index() + 1
              return history.pushState(
                null,
                null,
                url + "#question-" + currentPanel
              )
            },
          },

          prev: {
            button: ".panel.review .actionLeft",
            key: null,
          },
          next: {
            button: ".panel.review .actionRight",
            key: null,
          },
          pagination: ".panel.review .topNav .uiCycleNav",
        },
        { debug: false }
      )
      if (
        $(".carouselContainer.review")
          .triggerHandler("currentVisible")
          .hasClass("hasFeedback")
      ) {
        return $(".carouselContainer.review")
          .triggerHandler("currentVisible")
          .find(".mark-feedback-read-trigger")
          .click()
      }
    }
  }

  checkForFeedback() {
    const carousel = $(".carouselContainer.review")
    const nav = $(".uiCycleNav")
    return $(".uiCycleNav")
      .find("a")
      .each(function () {
        const index = $(this).index()
        const item = carousel.find('*[data-position="' + index + '"]')
        if (item.hasClass("hasFeedback")) {
          $(this).addClass("hasFeedback")
          return $(this).addClass(item.attr("id"))
        }
      })
  }

  panelScrollCheck() {
    const $el = $(".panel.review")
    const $next = $el.find(".actionRight")
    const $prev = $el.find(".actionLeft")
    const panelOrigin = 1
    const currentPanel = $el.find(".uiCycleNav").find(".selected").index() + 1
    const panelCount = $el.find(".item").length
    if (currentPanel === panelOrigin) {
      $prev.fadeOut("300")
      return $next.fadeIn("300", "easeOutQuart")
    } else if (currentPanel === panelCount) {
      $prev.fadeIn("300", "easeOutQuart")
      return $next.fadeOut("300")
    } else {
      $prev.fadeIn("300", "easeOutQuart")
      return $next.fadeIn("300", "easeOutQuart")
    }
  }

  /*
  General binding of event to els on page.
  */
  bindElements() {
    const self = this

    // Live events for elements in panels
    $("#panels").on("click.lessonsAll", ".nextQ a", function (e) {
      const $panel = $(this).parents(".panel")
      e.preventDefault()
      $panel.find("button.actionRight").click()
      return $panel.find(".flashMessages").hide().find(".flash").hide()
    })

    $("#panels").on("click.lessonsAll", ".nextS a", function (e) {
      const $panel = $(this).parents(".panel")
      e.preventDefault()
      self.nextPanel()
      return $panel.find(".flashMessages, .flash").hide()
    })

    $("#panels").on(
      "click.lessonsAll",
      "button.try, .uiCycleNav a",
      function (e) {
        const $panel = $(this).parents(".panel")
        e.preventDefault()
        return $panel.find(".flashMessages").hide().find(".flash").hide()
      }
    )

    return $("#panels").on("click.lessonsAll", "div.a label", function (e) {
      return $(this)
        .parents(".as")
        .find(".selected")
        .removeClass("selected")
        .end()
        .end()
        .parents(".a")
        .addClass("selected")
    })
  }

  bindLessonToolbar() {
    return $(".nav-toolbar .share-lesson").on("click", e => {
      const targetUrl = $(e.currentTarget).attr("data-url")
      const method = $(e.currentTarget).attr("data-method")
      const confirmMessage = $(e.currentTarget).attr("data-confirm")

      if (targetUrl === "#") {
        return
      }

      if (typeof confirmMessage === "undefined" || confirm(confirmMessage)) {
        $.ajax({
          type: method,
          url: targetUrl,
          dataType: "script",
        })
      }

      return false
    })
  }

  /*
  Event Handler to shift to the next panel
  @param  {Object} e Event (jquery) object.
  @param  {String} [caller] A string telling who is calling this event.
  @return {Boolean}
  */
  nextPanel(e, caller) {
    const $next = $(".uiToggleSwitch .active")
      .parents("li")
      .next("li")
      .children("a")
    if (caller === "videoState" && this.$videoContainer.is(".isRight")) {
      return false
    }
    return $next.click()
  }

  bindLogView() {
    return $(".uiToggleSwitch").click(() => {
      return this.logView()
    })
  }

  logView() {
    // only log views on the lesson/show page
    if ($(".lessonsShowView").length === 0) {
      return
    }

    // only log views once
    if ($(document.body).data("viewLogged") === true) {
      return
    }

    const split_path = window.location.pathname.split("/")
    const path_prefix = split_path[1] // This could be 'on' or 'lessons'
    const lesson_id = split_path[2]
    const url = "/lesson_views?lesson_id=" + lesson_id
    $.ajax({
      type: "POST",
      url,
      dataType: "script",
      beforeSend(xhr) {
        return xhr.setRequestHeader(
          "X-CSRF-Token",
          $('meta[name="csrf-token"]').attr("content")
        )
      },
    })

    // let's only do this once
    return $(document.body).data("viewLogged", true)
  }

  logEnded() {
    // only log ended on the lesson/show page
    if ($(".lessonsShowView").length === 0) {
      return
    }

    // only log ended once
    if ($(document.body).data("endedLogged") === true) {
      return
    }

    const split_path = window.location.pathname.split("/")
    const path_prefix = split_path[1] // This could be 'on' or 'lessons'
    const lesson_id = split_path[2]
    if (lesson_id === undefined) {
      return
    }

    const url = "/lesson_activities/completed?lesson_id=" + lesson_id
    $.ajax({
      type: "POST",
      url,
      dataType: "script",
      beforeSend(xhr) {
        return xhr.setRequestHeader(
          "X-CSRF-Token",
          $('meta[name="csrf-token"]').attr("content")
        )
      },
    })

    // let's only do this once
    return $(document.body).data("endedLogged", true)
  }
}
